import { useEffect, useState } from 'react';
import { api } from '../../../lib/api';
import { machinesApi } from '../../../lib/apis';
import { Machine } from '../../../types/machines';
import { Video } from '../../../types/videos';

export function useMachineDetail(id: string) {
  const [data, setData] = useState<Machine | null>(null);
  const [videos, setVideos] = useState<Video[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [productCounts, setProductCounts] = useState<{ active: number; inactive: number }>({ active: 0, inactive: 0 });

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const [mRes, vRes, pRes] = await Promise.all([
        api.get<{ data: Machine }>(`/machines/${id}`),
        machinesApi.get<{ data: Video[] }>(`/machines/${id}/videos`),
        machinesApi.get<{ data: any[] }>(`/machines/${id}/products`),
      ]);
      setData(mRes.data);
      setVideos((vRes as any)?.data || (vRes as any) || []);
      const products = ((pRes as any)?.data?.data || (pRes as any)?.data || []) as any[];
      let active = 0, inactive = 0;
      for (const p of products) {
        const isActive = typeof p.active === 'boolean' ? !!p.active : true;
        if (isActive) active++; else inactive++;
      }
      setProductCounts({ active, inactive });
    } catch (e: any) {
      setError(e.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { data, videos, loading, error, productCounts, reload: load };
}
